import { on } from 'delegated-events'
import throttle from 'lodash/throttle'
import { gsap } from 'gsap'

const selector = document.querySelector('.circle-selector')

const positionSelector = () => {
  const items = selector.querySelectorAll('.circle-item')
  const width = selector.offsetWidth
  const height = selector.offsetHeight
  const radius = width * 0.5

  let angle = 0
  const step = (2 * Math.PI) / items.length

  items.forEach((el) => {
    const line = selector.querySelector(`.circle-item-line[data-index="${el.dataset.index}"]`)

    const itemWidth = el.offsetWidth
    const itemHeight = el.offsetHeight

    const x = Math.round(width / 2 + radius * Math.cos(angle) - itemWidth / 2)
    const y = Math.round(height / 2 + radius * Math.sin(angle) - itemHeight / 2)

    line.style.transform = `rotate(${angle}rad)`
    line.style.width = `${radius}px`

    el.style.left = `${x}px`
    el.style.top = `${y}px`

    angle += step
  })
}

const setupAnimation = () => {
  const center = selector.querySelector('.circle-center')
  const items = selector.querySelectorAll('.circle-item')
  const lines = selector.querySelectorAll('.circle-item-line')

  gsap.set(center, { opacity: 0 })
  gsap.set(lines, { opacity: 0 })
  gsap.set(items, { opacity: 0 })

  selector.classList.add('is-init')

  const timeline = gsap.timeline({
    paused: true,
  })

  timeline.to(center, { opacity: 1, duration: 1, delay: 0.25 })
  timeline.to(lines, { opacity: 1, stagger: 0.1 })
  timeline.to(items, { opacity: 1, stagger: 0.2 })

  timeline.play()
}

const handleModalOpen = (e) => {
  e.preventDefault()

  const item = e.target.closest('.circle-item')
  const modal = document.querySelector(`.circle-item-modal[data-index="${item.dataset.index}"]`)

  if (modal) {
    gsap
      .timeline()
      .to('.circle-selector', { opacity: 0, duration: 0.5 })
      .fromTo(
        modal,
        {
          opacity: 0,
          y: '20%',
        },
        {
          opacity: 1,
          y: 0,
          onStart: () => {
            modal.classList.add('is-active')
          },
        }
      )
  }
}

const handleModalClose = (e) => {
  const modal = e.target.closest('.circle-item-modal')

  gsap
    .timeline()
    .fromTo(
      modal,
      {
        opacity: 1,
        y: 0,
      },
      {
        opacity: 0,
        y: '-20%',
        onStart: () => {
          modal.classList.remove('is-active')
        },
      }
    )
    .to('.circle-selector', { opacity: 1, duration: 0.5 })
}

if (selector) {
  document.addEventListener('DOMContentLoaded', () => {
    positionSelector()
    setupAnimation()
  })

  window.addEventListener('resize', throttle(positionSelector, 250))

  on('click', '.circle-item:not(.no-modal)', handleModalOpen)
  on('click', '.circle-item-modal-close', handleModalClose)
}
